import axios from '@/plugins/axios';

/**
 * 获取token
 */
export const token = () => {
    return axios({
        url: `/bus/index/getToken`,
        method: 'get'
    }).then(res => res.data);
};

/**
 * 获取城市列表
 */
export const area = () => {
    return axios({
        url: `/bus/area/get/all`,
        method: 'get'
    }).then(res => res.data);
};

/**
 * 获取站点
 * @param areaCode 
 */
export const stations = (params: any) => {
    return axios({
        url: `/bus/station/get/siteNameLike`,
        method: 'get',
        params
    }).then(res => res.data);
};

/**
 * 获取所有线路
 * @param areaCode 
 */
export const lines = (areaCode: any) => {
    return axios({
        url: `/bus/line/get/areaCode`,
        method: 'get',
        params: {
            areaCode
        }
    }).then(res => res.data);
};

/**
 * 根据lineName获取线路信息
 * @param params 
 */
export const searchLine = (params: any) => {
    return axios({
        url: `/bus/line/get/lineName`,
        method: 'get',
        params
    }).then(res => res.data);
};

/**
 * 线路详情
 * @param params
 */
export const detail = (params: any) => {
    return axios({
        url: `/bus/line/get/details`,
        method: 'get',
        params
    }).then(res => res.data);
};

/**
 * 搜索
 */
export const search = (params: any) => {
    return axios({
        url: `/bus/station/get/search`,
        method: 'get',
        params
    }).then(res => res.data);
};

/**
 * 根据线路查车辆
 */
export const cars = (params: any) => {
    return axios({
        url: `/bus/line/get/lineCars`,
        method: 'get',
        params
    }).then(res => res.data);
};

/**
 * 获取热门站点信息
 */
export const hotBusSite = (areaCode: any) => {
    return axios({
        url: `/bus/station/get/evcasHotBusSite`,
        method: 'get',
        params: {
            areaCode
        }
    }).then(res => res.data);
};

/**
 * 根据siteName获取站点信息
 */
export const searchSite = (params: any) => {
    return axios({
        url: `/bus/station/get/siteName`,
        method: 'get',
        params
    }).then(res => res.data);
};

/**
 * 获取微信签名
 */
export const getWeChatSignature = (params: any) => {
    return axios({
        url: `/bus/index/getWeChatSignature`,
        method: 'get',
        params
    }).then(res => res.data);
};

export const getCityCode = (params: any) => {
    return axios({
        url: `/bus/index/regeo`,
        method: 'get',
        params
    }).then(res => res.data);
};
